import { gql } from '@apollo/client'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const LOCATION_TYPE_CATEGORY_QUERY = gql`
  query locationTypeCategory($id: ID!) {
    locationTypeCategory(id: $id) {
      id
      name
      description
      position
      maxPosition
      updatedAt
      isMain
      updatedBy {
        id
        name
      }
      node {
        ...LocationTypeCategoryNodeFragment
      }
    }
  }
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
`

export default LOCATION_TYPE_CATEGORY_QUERY
